import { useQuery } from '@tanstack/react-query';

import { fetchBranchList } from '../../data-provider/select-options';
import type { GetBranchListRequestParams } from '../../data-provider/select-options/branch/api';

export const useGetBranchList = (params?: GetBranchListRequestParams) => {
  return useQuery({
    enabled: Boolean(params?.divisionKey) && Boolean(params?.regionKey),
    queryFn: () => fetchBranchList(params),
    queryKey: ['claims-loss-and-damage-branch-list', params?.divisionKey, params?.regionKey],
    staleTime: Number.POSITIVE_INFINITY,
  });
};
